<div class="d-flex w-100">
    <telxl-search
        [searchText]="searchText()"
        (searchTextChange)="searchChanged($event)"
        [disabled]="disabled()"
        id="customer-directory-search"
        class="w-100"
    />
    @if (showBusinessUnitFilter()) {
        <div class="ms-2">
            <telxl-dropdown
                size="sm"
                colour="dropdown"
                [outline]="true"
                position="bottom-end"
                [menuItems]="businessUnitMenuItems()"
                [disabled]="disabled()"
                [selected]="businessUnit"
                (selectedChange)="businessUnit = $event"
            />
        </div>
    }
    @if (showMediaFilter()) {
        <div class="ms-2">
            <telxl-dropdown
                size="sm"
                colour="dropdown"
                [outline]="true"
                position="bottom-end"
                [menuItems]="mediaMenuItems"
                [disabled]="disabled()"
                [selected]="media"
                (selectedChange)="media = $event"
            />
        </div>
    }
    @if (canCreateCustomer()) {
        <div class="ms-2" [style.min-width.ch]="'15'">
            <telxl-button
                size="sm"
                colour="primary"
                [outline]="true"
                [disabled]="disabled()"
                (buttonClick)="createNewCustomer()"
            >
                <i class="fa-solid fa-user-plus me-1"></i>
                New Contact
            </telxl-button>
        </div>
    }
</div>

<div class="d-flex w-100" #createCustomerContaner>
    @if (createCustomer() && !disabled()) {
        <telxl-shared-end-customer-details-form
            class="w-100"
            (complete)="completeCreateCustomer()"
            (cancelled)="cancelCreateCustomer()"
        />
    }
</div>
<div
    #scrollContainer
    class="scroll-container mt-2"
    [style.height]="calculateHeight()"
    [style.max-height]="calculateHeight()"
>
    @for (listing of listings(); track listing.id) {
        <telxl-shared-directory-listing-item
            source="end-customers"
            [customButtonTemplate]="customButtonTemplate()"
            [item]="listing"
            [mode]="mode()"
            [highlight]="highlight() === listing.id"
            [displayMediaIcons]="displayMediaIcons()"
            [disabled]="disabled()"
            [selected]="{
                item: selected()?.item ?? [],
                selected: selected()?.id === listing.id,
            }"
            (selectedChange)="selectedChanged($event)"
        />
    } @empty {
        @if (!isLoading()) {
            <div
                class="d-flex flex-column align-items-center justify-content-center h-100"
            >
                <i class="fa-thin fa-face-zipper text-primary"></i>
                <div class="font-xxl mt-4">No data!</div>
                <div class="mt-4">No end customers were found.</div>
            </div>
        } @else {
            <div class="h-100 w-100">
                <telxl-loading size="3rem" />
            </div>
        }
    }
</div>
